import { render, staticRenderFns } from "./NewServiceDialog.vue?vue&type=template&id=2854f536&"
import script from "./NewServiceDialog.vue?vue&type=script&lang=js&"
export * from "./NewServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewServiceDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports